<template>
  <div class="fill flex column comments_container p4" :class="`comments_container_${commentsid}`" v-if="$store.state.app.basics.modules &&
    $store.state.app.basics.modules.indexOf('comments') > -1
    ">

    
    
    <div class="flex center" v-if="!$store.state.comments[commentsid] ||
    Object.keys($store.state.comments[commentsid]).length === 0
    ">
      <a href @click.prevent="$store.state.show.auth = true" v-if="!$store.state.auth.uid">Login to comment.</a>
    </div>
    <div :key="$store.state.counter + commentKey" v-for="(comment, commentKey) in orderByDate(
    $store.state.comments[commentsid]
  )" :style="`opacity: ${Number(1 - 0.0625 * depth)}; font-size: ${100 / Number(1 + 0.05 * depth)
    }%;`">
      <div v-if="comment !== null &&
    (comment.published ||
      $store.state.app.user.includes($store.state.auth.uid) ||
      ($store.state.app.advanced.roles.admin &&
        $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.includes(
          $store.state.auth.uid
        )))
    " class="comment flex column wrap b8">
        <div class="flex flexy md-font column container">
          <div class="flex between align-center xs-font p4">
            <div class="flex flexy align-center">
              <span class="flex" v-if="comment.user === $store.state.auth.uid">
                <i @click="
    $store.commit('set', {
      keys: ['show', 'commentEdit'],
      val: comment.id,
    })
    " class="fas fa-edit r4"></i>
                <code @click="
    $store.commit('set', {
      keys: ['show', 'commentEdit'],
      val: false,
    })
    " v-if="$store.state.show.commentEdit === comment.id" class="xs-font flex align-center">Cancel</code>
              </span>
              <user :userid="comment.user"></user>
            </div>
            <div class="flex between align-center">
              <itime class="r8 update-text" :timestamp="comment.timestamp"></itime>
              <!-- <i v-if="comment.type" class="xs-font p4">{{ comment.type }}</i> -->
            </div>
          </div>
          <div class="flex sm-font wrap align-center p4" v-if="$store.state.show.commentEdit == comment.id">
            <!-- attachments edit/removal -->
            <textarea autofocus="true" v-model="comment.text" class="flexw b4 r4"></textarea>
            <media view="compact" attachid select v-model="comment.media"></media>
            <div class="flex wrap align-center p4 flexy around">
              <button :disabled="comment.text.length < 1" type="button" class="update p8 r4 flexy" @click="
    update(comment, commentsid);
  $store.commit('set', {
    keys: ['show', 'commentEdit'],
    val: false,
  });
  ">
                <i class="fa fa-save fa-lg"></i>
              </button>
              <div class="flex column">
                <code @click="remove(commentsid, comment.id)" v-if="comment.user === $store.state.auth.uid &&
    $store.state.show.commentEdit === comment.id
    " class="flex align-center xs-font">
                  <i class="far fa-trash-alt r4"></i>Remove
                </code>
              </div>
            </div>
          </div>
          <!-- attachments -->
          <div v-else>
            <!-- <short v-if="comment.text.length > 160 && !show.expand" @click="show.expand = true" :str="comment.text" len="140"/> -->
            <icontent :media="comment.media" :content="comment.text" class="p4" />
            <!-- <div class="xs-font">{{ comment }}</div> -->
          </div>
          <div class="flex between xs-font align-center l4 r4">
            <label v-if="$store.state.app.user.includes($store.state.auth.uid) ||
    ($store.state.app.advanced.roles.admin &&
      $store.state.app.advanced.roles.admin.members &&
      $store.state.app.advanced.roles.admin.members.includes(
        $store.state.auth.uid
      ))
    ">Published<input @change="update(comment, comment.id)" type="checkbox"
                v-model="comment.published" /></label>
            <reputation :key="$store.state.counter + comment.id" :f-id="comment.id" f-type="comments"
              class="flex xs-font"></reputation>
            <span @click="
    $store.commit('set', {
      keys: ['responses', comment.id],
      val: !$store.state.responses[comment.id],
    })
    ">Replies
              <i :class="!$store.state.responses[comment.id]
      ? 'fas fa-chevron-down r4'
      : 'fas fa-chevron-up'
    "></i></span>
          </div>
        </div>
        <comments v-if="comment && $store.state.responses[comment.id]" :commentsid="comment.id" :depth="depth + 1 || 1">
        </comments>
      </div>
      <code v-if="comment && $store.state.responses[comment.id]" class="xs-font flex align-center b8" @click="
    $store.commit('setState', {
      prop: 'responses',
      prop2: comment.id,
      val: false,
    });
  $store.commit('setState', {
    prop: 'reply',
    prop2: comment.id,
    val: !$store.state.reply[comment.id],
  });
  ">
        <i class="fas fa-chevron-up r4 p8"></i>
      </code>
    </div>
    <!-- {{ newComment }} -->
    <button class="xs-font" href @click="show.newComment = !show.newComment">--- respond</button>
    <!-- <button class="xs-font update-border" href @click="show.newComment = !show.newComment">respond to: <short len="9" str="comment.text"/></button> -->

    <div v-if="(commentsid ||
      $route.name === commentsid ||
      $route.params.id === commentsid ||
      $route.params.iitemid === commentsid ||
      commentsid === 'onboard') &&
    $store.state.auth.uid && show.newComment
    " class="fill b8">
      <textarea style="align-self: stretch" class="flexy fill flex" v-model="newComment.text"
        placeholder="Comment or update"></textarea>

      <div class="flex" style="align-self: stretch">
        <!-- <select v-model="newComment.type">
          <option :value="type" v-for="type in ['idea', 'reaction', 'question', 'answer']" :key="'newComment.'+type">{{type}}</option>
        </select> -->
        <media view="compact" attachid select v-model="newComment.media"></media>
        <button :disabled="!newComment.text || newComment.text.length < 1" type="button" class="p4 l4 update fill"
          @click="
    post(
      commentsid || $route.params.id || $route.params.iitemid,
      newComment
    );
  newComment.text = '';
  ">
          <i class="fas fa-paper-plane"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue'
import _ from "lodash";

export default {
  data() {
    return {
      test: "test",
      newComment: {
        type: "",
        text: "",
        published: true,
        media: []
      },
      newResponse: {},
      lo: _,
      show: {
        newComment: false,
        expand: false
      }
    };
  },
  computed: {
    // comments() {
    //   return this.queryComments();
    // },
  },
  methods: {
    queryComments() {
      return this.$store.dispatch("query", {
        type: "comments",
        id: this["commentsid"],
      });
    },
    remove(commentsid, id) {
      this.$store.dispatch("delete", {
        commentsid,
        id,
        type: "comments",
      });
    },
    post(id, comment) {
      // Takes the id of a comment or content then pushes the comment to it's respective comments array
      if (this.$store.state.auth.uid) {
        const fullComment = {
          type: comment.type,
          timestamp: Date.now(),
          text: comment.text,
          user: this.$store.state.auth.uid,
          published: true,
          media: comment.media
        };
        this.$store
          .dispatch("create", {
            id,
            comment: fullComment,
            type: "comments",
          })
          .then(() => {
            this.$set(
              this.$store.state.componentKeys,
              "comments",
              this.$store.state.componentKeys["comments"] + 1
            );
          });
      } else {
        setTimeout(() => {
          this.post(id, comment);
        }, 1000);
      }
    },
    orderByDate(set) {
      return _.orderBy(set, "timestamp", "asc");
    },
    update(comment) {
      comment.type = "comments";
      comment["commentsid"] = this["commentsid"];
      this.$store.dispatch("update", comment);
    },
  },
  created() {
    this.$store.dispatch("query", { type: "comments", id: this["commentsid"] });
  },
  name: "comments",
  props: { depth: { type: Number }, commentsid: { type: String } },
  watch: {
    "this.$store.state.comments": () => {
      this.$store.dispatch("query", {
        type: "comments",
        id: this["commentsid"],
      });
    },
  },
};
</script>
<style>
.comment-meta {
  margin: 8px 4px;
}

.comment-text {
  color: black;
  padding: 4px 8px;
  box-shadow: 0 2px 1px black;
  margin: 8px;
}

.comments_container {
  max-width: 560px;
  min-width: 270px;
}

.response {
  margin: 0 0 1px 0;
}

.response textarea {
  min-height: 96px;
}

.response button {
  min-height: 46px;
}

.response-actions {
  margin: 8px;
  min-width: 96px;
}
</style>
